import { render, staticRenderFns } from "./VisualRank.vue?vue&type=template&id=0bda0abe&"
import script from "./VisualRank.vue?vue&type=script&lang=js&"
export * from "./VisualRank.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports